import Http from './http'

export default {
	index(){
    return Http.get('/schedules')
  },
  indexByModel({model_name, model_id}){
    return Http.get(`/${model_name}/${model_id}/schedules`)
  },

  indexAgenda(filter){ // futuros
    // console.log({filter});
    return Http.get(`/agenda`, {params: {...filter}})
  },
  agendaCounters(filter){ // futuros
    // console.log({filter});
    return Http.get(`/agenda/counters`, {params: {...filter}})
  },

  show(id){
    return Http.get(`/schedules/${id}`)
  },

  create(schedule){
    return Http.post(`/schedules/`, {
      schedule: {
        ...schedule
      }
    })
  },
  update(schedule){
    return Http.put(`/schedules/${schedule.id}`, {
      schedule: {
        ...schedule
      }
    })
  },

  delete(id){
    return Http.delete(`/schedules/${id}`)
  },
}
